<template>
  <div class="interaction-body display-maximum fill-in-the-blank fill-in-the-blank-display-maximum">
    <div
      class="playposit-answer mt-2 mb-1 py-1 pr-1"
      :key="io.id"
      v-for="(io, idx) in localInteraction.interactionOptions"
    >
      <v-layout
        align-center
        justify-start
      >
        <v-icon
          class="mr-2"
          :size="24"
        >
          subtitles
        </v-icon>
        <v-chip
          v-for="(answer, index) in io.option.split(delimiter)"
          :key="`${answer}-${index}`"
        >
          {{ answer }}
        </v-chip>
      </v-layout>
      <text-box
        v-if="!!io.feedback.length"
        color-key="grey"
        title="Feedback"
        :text="io.feedback"
        :indent="false"
        title-classes="mb-1"
        tabindex="0"
        :aria-label="`Feedback for answer #${idx + 1}: ${io.option}. ${io.feedback.length ? io.feedback.stripHTML(['img', 'Image']) : ''}`"
        :attachments="io.interactionOptionFeedbackAttachments"
        :add-extra-space-above="true"
      ></text-box>
    </div>
    <v-layout
      v-if="typeof localInteraction.jumpCorrect === 'number'"
      class="caption muted mt-3"
      align-center
      justify-start
    >
      <v-icon small class="muted no-flex mr-1">call_split</v-icon>
      If correct, jumps to {{$convertTimestamp(localInteraction.jumpCorrect)}}.
    </v-layout>
    <v-layout
      v-if="typeof localInteraction.jumpIncorrect === 'number'"
      class="caption muted"
      :class="{
        'mt-3': typeof localInteraction.jumpCorrect !== 'number'
      }"
      align-center
      justify-start
    >
      <v-icon small class="muted no-flex mr-1">call_split</v-icon>
      If incorrect, jumps to {{$convertTimestamp(localInteraction.jumpIncorrect)}}.
    </v-layout>
  </div>
</template>

<script>
import TextBox from '../../Snippets/TextBox.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'FillInTheBlankDisplayMaximumInteractionBody',
  components: {
    TextBox,
  },
  mixins: [
    Interaction,
  ],
  computed: {
    correctAnswer() {
      return this.localInteraction.interactionOptions.find((io) => io.correct).option;
    },
  },
};
</script>
